import React from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Input, LegacyForm, Space, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardChecksTypeEnum } from "@payping/api";
import { DashboardRoutes } from "@/router/constant";
import { useHandleNavigationURL, useSaveToRedux } from "../../utils";
import { selectAtom } from "jotai/utils";
import { settingsBusinessAtom } from "@/mobile/Settings/state";
import { useAtom } from "jotai";
import { Trans } from "@payping/utils/localeUtils";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditOfficialBusinessName: React.FC = () => {
  const { t } = useAppTranslation();
  const [form] = LegacyForm.useForm();
  const checks = useAppSelector((state) => state.user.checks);
  const isBusinessDisabled = checks?.businessStatus === DashboardChecksTypeEnum.Confirmed;

  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const companyNameApi = useAppSelector((state) => state.user.businessInfo?.companyName);

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        placement={"bottom"}
        open={true}
        height={"100%"}
        title={`${t("edit")} / ${t("settings.business.officialBusinessName")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Space orientation={"vertical"}>
          <LegacyForm
            onFinish={({ companyName }) =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.officialBusinessSabtNumber.url,
                nextUrlForEdit: DashboardRoutes.settings.mEditBusiness.officialBusinessSabtNumber.url,
                fieldName: "companyName",
                fieldValue: companyName,
                setIsDrawerOpen: () => {},
              })
            }
            form={form}
            initialValues={{ companyName: mobileFormEditState.companyName ?? companyNameApi }}
          >
            <LegacyForm.Item label={t("settings.business.officialBusinessName")} name="companyName">
              <Input disabled={!form.getFieldValue("companyName") ? false : isBusinessDisabled} />
            </LegacyForm.Item>
          </LegacyForm>
          <Typography.Text className="tw:whitespace-pre-line" type={"secondary"}>
            <Trans
              i18nKey={"mobileEditPersonal.nameDesc"}
              components={[
                <Typography.Link
                  key={0}
                  href={"https://irsherkat.ssaa.ir/Design/SearchCompanyPublicInfo.aspx"}
                  target="_blank"
                />,
              ]}
            />
          </Typography.Text>
        </Space>
      </Drawer>
      <EditActionButtons onAccept={form.submit} acceptText={t("next")} />
    </>
  );
};

export default MobileEditOfficialBusinessName;
